/* Makers Manifest: page effects.
   mmInit(root) wires up everything inside root; it runs on load and again on a section
   the theme editor re-renders. The scroll loop and the cursor run once for the whole page. */
(function(){
var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var T = window.mmStrings || {};
var litWords = [];

function mmInit(root){
  root = root || document;

  /* ---------- mobile menu ---------- */
  var burger=root.querySelector('.burger'), menu=document.getElementById('mmenu');
  if(burger&&menu){
  burger.addEventListener('click',function(){var o=menu.hidden;menu.hidden=!o;burger.setAttribute('aria-expanded',String(o));burger.setAttribute('aria-label',o?T.closeMenu:T.openMenu);});
  menu.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){menu.hidden=true;burger.setAttribute('aria-expanded','false');});});
  }
  root.querySelectorAll('a[href="#"]').forEach(function(a){a.addEventListener('click',function(e){e.preventDefault();});});

  /* tables in page and policy texts scroll inside their own box on small screens */
  root.querySelectorAll('.rte table').forEach(function(t){
    if(t.parentElement.classList.contains('table-scroll'))return;
    var w=document.createElement('div');w.className='table-scroll';w.tabIndex=0;w.setAttribute('role','region');
    var cap=t.querySelector('tr');w.setAttribute('aria-label',cap?cap.textContent.replace(/\s+/g,' ').trim():'');
    t.parentNode.insertBefore(w,t);w.appendChild(t);
  });

  /* chapters of legal texts get an address from their title ("16. DREPTUL DE RETRAGERE..." -> #dreptul-de-retragere-din-contract),
     so the footer can link straight to a chapter of the terms */
  var legal=root.querySelectorAll('.shopify-policy__body h2,.shopify-policy__body h3,.legal-body h2,.legal-body h3');
  if(legal.length){
    legal.forEach(function(h){
      if(h.id)return;
      var slug=h.textContent.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/^\s*[\d.]+\s*/,'').replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');
      if(slug&&!document.getElementById(slug))h.id=slug;
    });
    if(location.hash){var t=document.getElementById(decodeURIComponent(location.hash.slice(1)));if(t)setTimeout(function(){t.scrollIntoView();},0);}
  }

  /* "Setări cookie-uri" reopens Shopify's cookie banner; without the banner it opens the cookie policy */
  root.querySelectorAll('[data-cookie-settings]').forEach(function(b){
    b.addEventListener('click',function(e){
      if(window.privacyBanner&&typeof window.privacyBanner.showPreferences==='function'){e.preventDefault();window.privacyBanner.showPreferences();}
    });
  });

  /* ---------- hero: the question forms from specks ---------- */
  var h1=root.querySelector('#hero-title'), cv=root.querySelector('#specks'), hero=root.querySelector('.hero');
  if(h1&&cv&&hero){
  function form(){
    if(reduce || !cv.getContext) return;
    var ctx=cv.getContext('2d'); if(!ctx) return;
    var dpr=Math.min(window.devicePixelRatio||1,2);
    var hr=hero.getBoundingClientRect();
    var W=hr.width, H=hr.height;
    cv.width=W*dpr; cv.height=H*dpr;
    var cs=getComputedStyle(h1), fsz=parseFloat(cs.fontSize);
    var font=cs.fontWeight+' '+fsz+'px '+cs.fontFamily;
    var off=document.createElement('canvas'); off.width=cv.width; off.height=cv.height;
    var o=off.getContext('2d'); o.scale(dpr,dpr); o.font=font; o.fillStyle='#fff'; o.textBaseline='alphabetic';
    var ls=parseFloat(cs.letterSpacing)||0; if('letterSpacing' in o) o.letterSpacing=ls+'px';
    h1.querySelectorAll('.w').forEach(function(s){
      var r=s.getBoundingClientRect(), m=o.measureText(s.textContent);
      var asc=m.fontBoundingBoxAscent||fsz*0.92;
      o.fillText(s.textContent, r.left-hr.left, r.top-hr.top+asc);
    });
    var data=o.getImageData(0,0,off.width,off.height).data, pts=[];
    var step=Math.max(2,Math.round(3*dpr)), minX=1e9,maxX=0;
    for(var y=0;y<off.height;y+=step){for(var x=0;x<off.width;x+=step){if(data[(y*off.width+x)*4+3]>140){var tx=x/dpr,ty=y/dpr;pts.push({tx:tx,ty:ty,sx:tx-(140+Math.random()*420),sy:ty+(Math.random()-.5)*220,d:0,s:1.4+Math.random()*1.6});if(tx<minX)minX=tx;if(tx>maxX)maxX=tx;}}}
    if(!pts.length) return;
    var span=maxX-minX||1;
    pts.forEach(function(p){p.d=((p.tx-minX)/span)*650+Math.random()*260;});
    h1.classList.add('forming');
    ctx.setTransform(dpr,0,0,dpr,0,0); ctx.fillStyle='#fff';
    var DUR=1150, END=650+260+DUR, t0=null, revealed=false;
    function ease(t){return 1-Math.pow(1-t,3);}
    function frame(ts){
      if(t0===null)t0=ts; var t=ts-t0;
      ctx.clearRect(0,0,W,H);
      for(var i=0;i<pts.length;i++){var p=pts[i],k=(t-p.d)/DUR; if(k<=0)continue; if(k>1)k=1; var e=ease(k);
        ctx.globalAlpha=Math.min(1,k*1.8); var sz=p.s+(2.6-p.s)*e;
        ctx.fillRect(p.sx+(p.tx-p.sx)*e, p.sy+(p.ty-p.sy)*e, sz, sz);}
      if(t>END-220 && !revealed){revealed=true;h1.classList.add('formed');h1.classList.remove('forming');}
      if(t<END+260){requestAnimationFrame(frame);}else{cv.style.transition='opacity .5s';cv.style.opacity='0';}
    }
    requestAnimationFrame(frame);
    setTimeout(function(){h1.classList.remove('forming');},4000); /* safety */
  }
  (document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve()).then(function(){ try{form();}catch(e){h1.classList.remove('forming');} });
  }


  /* ---------- size guide dialog ---------- */
  root.querySelectorAll('[data-sg-open]').forEach(function(btn){
    var dlg=btn.parentNode.querySelector('[data-sg]'); if(!dlg) return;
    function show(k){ dlg.querySelectorAll('[data-sg-panel]').forEach(function(p){p.hidden=p.getAttribute('data-sg-panel')!==k;}); dlg.querySelectorAll('[data-sg-tab]').forEach(function(b){b.setAttribute('aria-selected',b.getAttribute('data-sg-tab')===k?'true':'false');}); }
    btn.addEventListener('click',function(){
      var cut=root.querySelector('.opt-main input:checked'), tabs=dlg.querySelectorAll('[data-sg-tab]');
      if(cut&&tabs.length){ tabs.forEach(function(b){ if(b.textContent.trim()===cut.value) show(b.getAttribute('data-sg-tab')); }); }
      if(dlg.showModal) dlg.showModal(); else dlg.setAttribute('open','');
    });
    dlg.querySelectorAll('[data-sg-tab]').forEach(function(b){ b.addEventListener('click',function(){ show(b.getAttribute('data-sg-tab')); }); });
    dlg.querySelector('[data-sg-close]').addEventListener('click',function(){ dlg.close(); });
    dlg.addEventListener('click',function(e){ if(e.target===dlg) dlg.close(); });
  });
  /* ---------- hero photo: its edge erodes into black, like "Manifest" in the logo ---------- */
  var fig=root.querySelector('.hero-visual'), ec=root.querySelector('#erode'), noise=null, ncols=0, nrows=0;
  if(fig&&ec){
  function buildNoise(c,r){
    var gw=Math.ceil(c/9)+2, gh=Math.ceil(r/9)+2, g=new Float32Array(gw*gh), n=new Float32Array(c*r);
    for(var i=0;i<g.length;i++)g[i]=Math.random();
    for(var y=0;y<r;y++)for(var x=0;x<c;x++){
      var fx=x/9, fy=y/9, x0=fx|0, y0=fy|0, tx=fx-x0, ty=fy-y0;
      var a=g[y0*gw+x0], b=g[y0*gw+x0+1], cc=g[(y0+1)*gw+x0], d=g[(y0+1)*gw+x0+1];
      var v=(a*(1-tx)+b*tx)*(1-ty)+(cc*(1-tx)+d*tx)*ty;
      n[y*c+x]=v*0.55+Math.random()*0.45;
    }
    return n;
  }
  function drawErode(p){
    var W=fig.clientWidth, H=fig.clientHeight; if(!W||!H) return;
    /* phones and tablets: no specks, the photo fades smoothly into black (CSS mask) */
    if(window.innerWidth<=1020){ec.width=1;ec.height=1;return;}
    var cell=3, c=Math.ceil(W/cell), r=Math.ceil(H/cell);
    if(c!==ncols||r!==nrows){ncols=c;nrows=r;noise=buildNoise(c,r);}
    ec.width=c; ec.height=r;
    var ctx=ec.getContext('2d'), img=ctx.createImageData(c,r), d=img.data;
    var vertical=window.innerWidth<=1020, E=vertical?0.32:0.42, shift=(1-p)*(1+E);
    for(var y=0;y<r;y++)for(var x=0;x<c;x++){
      var u=vertical?y/r:x/c;
      var tval=(u-shift)/E;
      var k=(y*c+x)*4;
      if(noise[y*c+x]>=tval){d[k]=0;d[k+1]=0;d[k+2]=0;d[k+3]=255;}
    }
    ctx.putImageData(img,0,0);
    ec.style.imageRendering='pixelated';
  }
  function erodeIn(){
    if(reduce){drawErode(1);return;}
    var t0=null,D=1700;
    function f(ts){if(t0===null)t0=ts;var k=Math.min(1,(ts-t0)/D);drawErode(1-Math.pow(1-k,3));if(k<1)requestAnimationFrame(f);}
    requestAnimationFrame(f);
  }
  drawErode(0); erodeIn();
  var rz; window.addEventListener('resize',function(){clearTimeout(rz);rz=setTimeout(function(){drawErode(1);},120);});
  }

  /* ---------- signup form: checked here, sent to Shopify as a customer form ---------- */
  var f=root.querySelector('#signup'), em=root.querySelector('#email'), cb=root.querySelector('#consent'), msg=root.querySelector('#form-msg'), btn=root.querySelector('#submit-btn');
  if(f&&em&&cb&&msg&&btn){
  var BTN=btn.innerHTML;
  function setState(st){
    btn.disabled=false; btn.innerHTML=BTN; em.removeAttribute('aria-invalid'); msg.className='msg'; msg.textContent='';
    if(st==='invalid'){em.setAttribute('aria-invalid','true');msg.className='msg err';msg.textContent=T.formInvalid;}
    if(st==='consent'){msg.className='msg err';msg.textContent=T.formConsent;}
    if(st==='sending'){btn.disabled=true;btn.textContent=T.formSending;}
  }
  f.addEventListener('submit',function(e){
    if(!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em.value.trim())){e.preventDefault();setState('invalid');em.focus();return;}
    if(!cb.checked){e.preventDefault();setState('consent');cb.focus();return;}
    setState('sending');
  });
  em.addEventListener('input',function(){if(em.getAttribute('aria-invalid')){em.removeAttribute('aria-invalid');msg.textContent='';}});
  }

  /* ---------- headings rise word by word ---------- */
  var rvs=[].slice.call(root.querySelectorAll('.rv'));
  rvs.forEach(function(h){
    var words=h.textContent.trim().split(/\s+/);
    h.innerHTML=words.map(function(w,i){return '<span class="rw"><span style="--i:'+i+'">'+w.replace(/&/g,'&amp;').replace(/</g,'&lt;')+'</span></span>';}).join(' ');
    if(!reduce)h.classList.add('pre');
  });
  /* ---------- reading text lights up word by word ---------- */
  if(!reduce){
    root.querySelectorAll('[data-lit] p').forEach(function(p){
      if(p.closest('.ben'))return; /* highlighted questions light up as a whole */
      p.classList.add('lit');
      /* wrap every word in its text nodes, so bold or highlighted words keep their markup */
      var walker=document.createTreeWalker(p,NodeFilter.SHOW_TEXT,null), nodes=[], n;
      while((n=walker.nextNode()))nodes.push(n);
      nodes.forEach(function(t){
        var parts=t.nodeValue.split(/(\s+)/), frag=document.createDocumentFragment();
        parts.forEach(function(part){
          if(!part)return;
          if(/^\s+$/.test(part)){frag.appendChild(document.createTextNode(part));return;}
          var w=document.createElement('span');w.className='wd';w.textContent=part;frag.appendChild(w);
        });
        t.parentNode.replaceChild(frag,t);
      });
      litWords=litWords.concat([].slice.call(p.querySelectorAll('.wd')));
    });
  }
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){en.target.classList.remove('pre');io.unobserve(en.target);}});},{rootMargin:'0px 0px -12% 0px'});
    rvs.forEach(function(h){io.observe(h);});
  } else rvs.forEach(function(h){h.classList.remove('pre');});

  /* ---------- founding member card video: loads near the viewport, plays only while visible ---------- */
  root.querySelectorAll('.f100-video').forEach(function(v){
    if(reduce || !('IntersectionObserver' in window)) return;   /* reduced motion: the poster stays */
    var vo=new IntersectionObserver(function(es){es.forEach(function(en){
      if(en.isIntersecting){
        if(v.dataset.src){v.src=v.dataset.src;v.removeAttribute('data-src');}
        var p=v.play(); if(p&&p.catch) p.catch(function(){});
      } else v.pause();
    });},{rootMargin:'200px 0px'});
    vo.observe(v);
  });

  mmProduct(root);

}

function mmProduct(root){
  /* gallery: a new photo forms from the logo's specks */
  var g=root.querySelector('.gallery');
  if(g){
    var data=[];try{data=JSON.parse(g.getAttribute('data-gallery'));}catch(e){}
    var main=g.querySelector('.g-main'), img=main.querySelector('img'), cv=main.querySelector('canvas'), cnt=main.querySelector('.g-count');
    var thumbs=[].slice.call(g.querySelectorAll('.g-thumb')), cur=+(g.getAttribute('data-start')||0), busy=false, noise=null, nc=0, nr=0;
    /* photos shown for the chosen cut: its own group plus the shared ones */
    var vis=data.map(function(d,i){return i;}).filter(function(i){return !thumbs[i]||!thumbs[i].hidden;});
    var cache=data.map(function(d){var i=new Image();i.src=d[0];return i;});
    function mkNoise(c,r){var gw=Math.ceil(c/7)+2,gh=Math.ceil(r/7)+2,gg=new Float32Array(gw*gh),n=new Float32Array(c*r);for(var i=0;i<gg.length;i++)gg[i]=Math.random();
      for(var y=0;y<r;y++)for(var x=0;x<c;x++){var fx=x/7,fy=y/7,x0=fx|0,y0=fy|0,tx=fx-x0,ty=fy-y0;var v=(gg[y0*gw+x0]*(1-tx)+gg[y0*gw+x0+1]*tx)*(1-ty)+(gg[(y0+1)*gw+x0]*(1-tx)+gg[(y0+1)*gw+x0+1]*tx)*ty;n[y*c+x]=v*.55+Math.random()*.45;}return n;}
    function cover(ctx,im,W,Hh){var r=Math.max(W/im.naturalWidth,Hh/im.naturalHeight),w=im.naturalWidth*r,h=im.naturalHeight*r;ctx.drawImage(im,(W-w)/2,(Hh-h)/2,w,h);}
    function show(i){
      if(i===cur||busy||!data[i])return;
      thumbs.forEach(function(t,k){t.setAttribute('aria-current',String(k===i));});
      if(cnt)cnt.textContent=(vis.indexOf(i)+1)+' / '+vis.length;
      var next=cache[i];
      function swap(){img.src=data[i][0];img.removeAttribute('srcset');img.alt=data[i][1];cur=i;}
      if(reduce||!cv.getContext||!next.complete){swap();return;}
      busy=true;
      var W=main.clientWidth,Hh=main.clientHeight,dpr=Math.min(window.devicePixelRatio||1,2);
      cv.width=W*dpr;cv.height=Hh*dpr;var ctx=cv.getContext('2d');
      var cell=4,c=Math.ceil(W/cell),r=Math.ceil(Hh/cell);if(c!==nc||r!==nr){nc=c;nr=r;noise=mkNoise(c,r);}
      var m=document.createElement('canvas');m.width=c;m.height=r;var mx=m.getContext('2d'),md=mx.createImageData(c,r);
      var t0=null,D=900;cv.style.opacity='1';
      function f(ts){if(t0===null)t0=ts;var k=Math.min(1,(ts-t0)/D),e=1-Math.pow(1-k,3);
        var d=md.data;for(var y=0;y<r;y++)for(var x=0;x<c;x++){var u=1-x/c;var on=noise[y*c+x]<(e*1.6-u*0.6);d[(y*c+x)*4+3]=on?255:0;}
        mx.putImageData(md,0,0);
        ctx.globalCompositeOperation='source-over';ctx.clearRect(0,0,cv.width,cv.height);ctx.imageSmoothingEnabled=false;ctx.drawImage(m,0,0,cv.width,cv.height);
        ctx.globalCompositeOperation='source-in';ctx.imageSmoothingEnabled=true;cover(ctx,next,cv.width,cv.height);
        if(k<1)requestAnimationFrame(f);else{swap();requestAnimationFrame(function(){cv.style.opacity='0';busy=false;});}}
      requestAnimationFrame(f);
    }
    function step(d){var k=vis.indexOf(cur);if(k<0)k=0;show(vis[(k+d+vis.length)%vis.length]);}
    thumbs.forEach(function(t){t.addEventListener('click',function(){show(+t.getAttribute('data-i'));});});
    /* swipe on the main photo */
    var sx=null;main.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;},{passive:true});
    main.addEventListener('touchend',function(e){if(sx===null)return;var dx=e.changedTouches[0].clientX-sx;sx=null;if(Math.abs(dx)>40)step(dx<0?1:-1);},{passive:true});
    main.addEventListener('click',function(){step(1);});
    main.style.cursor='pointer';
    g.setGroup=function(name){
      vis=[];data.forEach(function(d,i){var on=!d[2]||d[2]===name;if(thumbs[i])thumbs[i].hidden=!on;if(on)vis.push(i);});
      if(cnt){cnt.hidden=vis.length<2;cnt.textContent=(Math.max(0,vis.indexOf(cur))+1)+' / '+vis.length;}
      var own=vis.filter(function(i){return data[i][2]===name;});
      if(vis.indexOf(cur)<0||(own.length&&data[cur][2]!==name))show(own.length?own[0]:vis[0]);
    };
  }
  /* quantity stepper */
  var q=root.querySelector('#qty');
  if(q)root.querySelectorAll('.qty button').forEach(function(b){b.addEventListener('click',function(){var v=Math.max(1,Math.min(99,(parseInt(q.value,10)||1)+(+b.getAttribute('data-q'))));q.value=v;});});

  /* variant choice: picks the matching variant and updates price, stock, button and photo */
  var vj=root.querySelector('script[data-variants]'), pf=root.querySelector('form[data-product-form]');
  if(vj&&pf){
    var variants=[];try{variants=JSON.parse(vj.textContent);}catch(e){}
    var radios=[].slice.call(pf.querySelectorAll('input[data-option]'));
    var set=function(sel,html){root.querySelectorAll(sel).forEach(function(el){el.innerHTML=html;});};
    var stockEl=root.querySelector('[data-stock]'), hint=stockEl?stockEl.textContent:'', nOpts=root.querySelectorAll('fieldset.opt').length;
    radios.forEach(function(r){r.addEventListener('change',function(){
      var idx=+r.getAttribute('data-option');
      /* a new cut clears the size, so the visitor picks it again for that cut */
      if(idx===0)radios.forEach(function(x){if(x.closest('[data-required]')&&+x.getAttribute('data-option')!==0)x.checked=false;});
      var chosen=[];radios.forEach(function(x){if(x.checked)chosen[+x.getAttribute('data-option')]=x.value;});
      if(g&&g.setGroup&&chosen[0])g.setGroup(chosen[0]);
      /* chips and specs that belong to one cut follow the choice */
      if(chosen[0])document.querySelectorAll('.mm [data-cut]').forEach(function(el){el.hidden=el.getAttribute('data-cut')!==chosen[0];});
      var done=chosen.filter(function(x){return x!==undefined;}).length===nOpts;
      if(!done){
        pf.querySelector('[data-variant-id]').value='';
        if(stockEl){stockEl.textContent=hint;stockEl.classList.add('choose');}
        root.querySelectorAll('[data-add]').forEach(function(b){b.disabled=!b.hasAttribute('data-bar-add');if(b.getAttribute('data-choose'))b.textContent=b.getAttribute('data-choose');});
        return;
      }
      var v=variants.filter(function(x){return x.options.every(function(o,i){return o===chosen[i];});})[0];
      if(!v)return;
      pf.querySelector('[data-variant-id]').value=v.id;
      set('[data-price]',v.price);set('[data-bar-price]',v.bar);
      if(stockEl){stockEl.innerHTML=v.stock;stockEl.classList.remove('choose');}
      root.querySelectorAll('[data-add]').forEach(function(b){b.textContent=v.label;b.disabled=!v.available;});
      var note=root.querySelector('[data-preorder-note]');if(note)note.hidden=!v.preorder;
      if(window.history&&history.replaceState){var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState(null,'',u);}
    });});
  }
}


/* ---------- cart drawer: slides in from the right, works without leaving the page ---------- */
var CD={
  el:function(){return document.querySelector('[data-cart-drawer]');},
  page:function(){return document.querySelector('[data-cart-page]');},
  open:function(){var d=CD.el();if(!d)return false;CD.last=document.activeElement;d.classList.add('open');d.setAttribute('aria-hidden','false');document.documentElement.classList.add('cd-lock');var p=d.querySelector('.cd-panel');if(p)setTimeout(function(){p.focus();},50);return true;},
  close:function(){var d=CD.el();if(!d)return;d.classList.remove('open');d.setAttribute('aria-hidden','true');document.documentElement.classList.remove('cd-lock');if(CD.last&&CD.last.focus)CD.last.focus();},
  /* re-render the drawer (or the /cart page) and the cart counts in the header */
  refresh:function(){
    if(CD.page()){location.reload();return Promise.resolve();}
    return fetch('/?sections=cart-drawer',{headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(j){
      var html=j['cart-drawer'];if(!html)return;
      var tmp=document.createElement('div');tmp.innerHTML=html;
      var nb=tmp.querySelector('[data-cd-body]'), ob=document.querySelector('[data-cart-drawer] [data-cd-body]');
      if(nb&&ob)ob.innerHTML=nb.innerHTML;
    }).then(CD.counts);
  },
  counts:function(){
    return fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(c){
      document.querySelectorAll('.mm .cart').forEach(function(a){var b=a.querySelector('b');if(b)b.textContent=c.item_count;var l=a.getAttribute('aria-label');if(l)a.setAttribute('aria-label',l.replace(/\d+/,c.item_count));});
    });
  },
  change:function(key,q){
    var b=document.querySelector('[data-cd-body]');if(b)b.classList.add('busy');
    return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity:q})}).then(CD.refresh).then(function(){if(b)b.classList.remove('busy');});
  },
  add:function(body){
    return fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:body}).then(function(r){if(!r.ok)throw r;return r.json();});
  }
};
document.addEventListener('click',function(e){
  var t=e.target.closest&&e.target.closest('[data-cd-open],[data-cd-close],[data-cd-qty],[data-cd-add]');
  if(!t)return;
  if(t.hasAttribute('data-cd-open')){if(CD.open())e.preventDefault();return;}
  if(t.hasAttribute('data-cd-close')){if(t.closest('[data-cart-drawer]')){e.preventDefault();CD.close();}return;}
  if(t.hasAttribute('data-cd-qty')){e.preventDefault();CD.change(t.getAttribute('data-cd-qty'),Math.max(0,+t.getAttribute('data-q')));return;}
  if(t.hasAttribute('data-cd-add')){
    e.preventDefault();t.disabled=true;var fd=new FormData();fd.append('id',t.getAttribute('data-cd-add'));fd.append('quantity','1');
    CD.add(fd).then(CD.refresh).then(function(){t.disabled=false;CD.open();}).catch(function(){t.disabled=false;});
  }
});
document.addEventListener('keydown',function(e){if(e.key==='Escape'){var d=CD.el();if(d&&d.classList.contains('open'))CD.close();}});
/* gift message: the checkbox shows the field, the text is saved as the order note */
document.addEventListener('change',function(e){
  var t=e.target;
  if(t.matches&&t.matches('[data-cd-note-toggle]')){
    var ta=t.closest('.cd-note').querySelector('[data-cd-note]');ta.hidden=!t.checked;
    if(t.checked)ta.focus();else{ta.value='';CD.saveNote('');}
  }
  if(t.matches&&t.matches('[data-cd-note]'))CD.saveNote(t.value);
});
CD.saveNote=function(v){return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({note:v})});};
/* the sticky bar button, while no size is chosen yet, scrolls up to the choice instead of adding */
document.addEventListener('click',function(e){
  var b=e.target.closest&&e.target.closest('[data-bar-add]');if(!b)return;
  var f=document.getElementById(b.getAttribute('form')),id=f&&f.querySelector('[data-variant-id]');
  if(!id||id.value)return;
  e.preventDefault();
  var need=[].slice.call(f.querySelectorAll('fieldset.opt')).filter(function(fs){return !fs.querySelector('input:checked');})[0]||f;
  need.scrollIntoView({behavior:'smooth',block:'center'});
});
/* "Adaugă în coș" on a product page adds without leaving the page, then opens the drawer */
document.addEventListener('submit',function(e){
  var f=e.target;
  if(!f.matches||!f.matches('form[data-product-form]')||!CD.el())return;
  e.preventDefault();
  var btns=[].slice.call(document.querySelectorAll('[data-add]')), labels=btns.map(function(b){return b.innerHTML;});
  btns.forEach(function(b){b.disabled=true;b.textContent=T.cartAdding;});
  CD.add(new FormData(f)).then(CD.refresh).then(function(){CD.open();}).catch(function(){
    var st=f.querySelector('[data-stock]');if(st){st.textContent=T.cartAddError;st.classList.add('choose');}
  }).then(function(){btns.forEach(function(b,i){b.innerHTML=labels[i];b.disabled=false;});});
});

/* offer request form: required fields are checked next to each field before sending */
document.addEventListener('submit',function(e){
  var f=e.target;
  if(!f.matches||!f.matches('form[data-offer-form]'))return;
  var first=null;
  f.querySelectorAll('.b2b-field').forEach(function(box){
    var err=box.querySelector('[data-err]'), bad=false;
    if(box.hasAttribute('data-required-group')||box.hasAttribute('data-required-check')){bad=!box.querySelector('input:checked');}
    else{var c=box.querySelector('input,textarea');if(c&&c.required){var v=c.value.trim();bad=!v||(c.type==='email'&&!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v));c.setAttribute('aria-invalid',bad?'true':'false');}}
    if(err)err.hidden=!bad;
    if(bad&&!first)first=box.querySelector('input,textarea');
  });
  if(first){e.preventDefault();first.focus();return;}
  var b=f.querySelector('button[type=submit]');if(b){b.disabled=true;b.textContent=T.formSending;}
});
document.addEventListener('input',function(e){var box=e.target.closest&&e.target.closest('form[data-offer-form] .b2b-field');if(!box)return;var err=box.querySelector('[data-err]');if(err&&!err.hidden){err.hidden=true;e.target.removeAttribute('aria-invalid');}});
document.addEventListener('change',function(e){var box=e.target.closest&&e.target.closest('form[data-offer-form] [data-required-group],form[data-offer-form] [data-required-check]');if(box&&box.querySelector('input:checked')){var err=box.querySelector('[data-err]');if(err)err.hidden=true;}});
/* after a successful request, bring the confirmation into view */
(function(){var d=document.querySelector('[data-offer-done]');if(d){d.scrollIntoView({block:'center'});d.focus({preventScroll:true});}})();

/* ---------- one scroll loop for the whole page ---------- */
var bx=0, lastY=window.scrollY, vel=0;
function tick(){
  var y=window.scrollY, dy=y-lastY; lastY=y;
  vel=vel*0.9+dy*0.1;
  /* the band drifts, faster when you scroll */
  var mv=document.querySelector('.mm .band-move');
  if(mv&&!reduce){
    var half=mv.scrollWidth/2;
    bx-=0.6+Math.abs(vel)*0.9;
    if(half&&-bx>half)bx+=half;
    mv.style.transform='translate3d('+bx+'px,0,0)';
  }
  if(litWords.length){
    var line=window.innerHeight*0.72;
    for(var i=0;i<litWords.length;i++){var r=litWords[i].getBoundingClientRect();litWords[i].classList.toggle('on',r.top<line);}
  }
  /* header hides on scroll down */
  var hdr=document.querySelector('.mm .site-header'), menu=document.getElementById('mmenu');
  if(hdr&&(!menu||menu.hidden)){
    if(dy>4&&y>200)hdr.classList.add('away'); else if(dy<-4||y<200)hdr.classList.remove('away');
  }
  var proj=document.querySelector('.mm .project .ph');
  if(proj&&!reduce){var pr=proj.getBoundingClientRect();var c=(pr.top+pr.height/2-window.innerHeight/2)/window.innerHeight;proj.style.transform='translate3d(0,'+(c*-40)+'px,0)';}

  /* product page: buy bar appears once the buy box is off screen; section links follow the reader */
  var bar=document.querySelector('.mm .pbar'), box=document.querySelector('.mm .buy-box');
  if(bar&&box){var br=box.getBoundingClientRect(),on=br.bottom<0;bar.classList.toggle('on',on);if(hdr&&on&&window.innerWidth>680)hdr.classList.add('away');}
  var bens=[].slice.call(document.querySelectorAll('.mm .ben'));
  if(bens.length){
    var bl=window.innerHeight*0.55;
    bens.forEach(function(b){var r=b.getBoundingClientRect();b.classList.toggle('on',r.top<bl&&r.bottom>window.innerHeight*0.2);});
    if(!bens.some(function(b){return b.classList.contains('on');})){var last=bens[bens.length-1];if(last.getBoundingClientRect().bottom<=window.innerHeight*0.2)last.classList.add('on');}
  }
  var media=document.querySelector('.mm .ben-media img'), benSec=document.querySelector('.mm .pp-benefits');
  if(media&&benSec&&!reduce){var s=benSec.getBoundingClientRect(),p=Math.min(1,Math.max(0,-s.top/Math.max(1,s.height-window.innerHeight)));media.style.setProperty('--z',(1.12-p*0.1).toFixed(3));}
  var links=[].slice.call(document.querySelectorAll('.mm .pbar nav a'));
  if(links.length){
    var cid='';links.forEach(function(a){var t=document.querySelector(a.getAttribute('href'));if(t&&t.getBoundingClientRect().top<window.innerHeight*0.35)cid=a.getAttribute('href');});
    links.forEach(function(a){a.classList.toggle('cur',a.getAttribute('href')===cid);});
  }
  /* NEAT process: stages light up as they reach the reading line, the ring and the mobile rail follow */
  var procs=document.querySelectorAll('.mm [data-neat-proc]');
  for(var k=0;k<procs.length;k++){
    var pc=procs[k], steps=pc.querySelectorAll('.neat-proc-step'), list=pc.querySelector('.neat-proc-list');
    if(!steps.length||!list)continue;
    pc.classList.add('is-live');
    var pl=window.innerHeight*0.6, cur=1;
    for(var j=0;j<steps.length;j++){if(steps[j].getBoundingClientRect().top<pl)cur=Math.max(cur,+steps[j].dataset.i);}
    if(pc._cur!==cur){
      pc._cur=cur;
      pc.querySelectorAll('[data-i]').forEach(function(el){var i=+el.dataset.i;el.classList.toggle('on',i<=cur);el.classList.toggle('cur',i===cur);});
    }
    var lr=list.getBoundingClientRect();
    list.style.setProperty('--fill',Math.max(0,Math.min(lr.height,pl-lr.top-22)).toFixed(0)+'px');
  }
  requestAnimationFrame(tick);
}

/* ---------- cursor mark ---------- */
function cursor(){
  if(reduce||!window.matchMedia('(hover:hover) and (pointer:fine)').matches)return;
  var cur=document.createElement('div');cur.className='mm-cursor';cur.setAttribute('aria-hidden','true');
  var cw=document.createElement('div');cw.className='mm';cw.style.cssText='position:static;height:0;background:none';cw.appendChild(cur);document.body.appendChild(cw);
  var mx=-100,my=-100,cx=-100,cy=-100;
  window.addEventListener('mousemove',function(e){mx=e.clientX;my=e.clientY;cur.classList.add('on');},{passive:true});
  document.addEventListener('mouseleave',function(){cur.classList.remove('on');});
  document.addEventListener('mouseover',function(e){var t=e.target.closest&&e.target.closest('.mm a,.mm button,.mm input,.mm label');cur.classList.toggle('big',!!t);});
  (function loop(){cx+=(mx-cx)*0.18;cy+=(my-cy)*0.18;cur.style.transform='translate3d('+cx+'px,'+cy+'px,0)';requestAnimationFrame(loop);})();
}

function start(){mmInit(document);requestAnimationFrame(tick);cursor();}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();

/* theme editor: a re-rendered section gets its effects back */
document.addEventListener('shopify:section:load',function(e){
  litWords=litWords.filter(function(w){return w.isConnected;});
  mmInit(e.target);
});
})();
